<button #deepLinkButton (click)="attemptDeepLink()" style="display: none;"></button>

<div class="slider-container">
    <div class="deep-link-redirect-content">
        <div class="deep-link-redirect-image text-center mb-40">
            <img src="/assets/img/sms.svg" alt="">
        </div>
        <h2 class="texts mono-dark foo-fs-30 fw-bold mb-16 text-center">{{ 'co_branding.download_our_mobile_app' | translate }}</h2>
        <p class="texts mono-dark foo-fs-14 mb-40 text-center">{{ 'co_branding.use_aec_wallet_on_smartphone' | translate }}</p>

        <div class="d-flex justify-content-center gap-3">
            <a [href]="appConfig.ios" class="store-icon" target="_blank" rel="noopener noreferrer">
                <img src="/assets/img/aec-wallet/app-store.svg" alt="Apple Store" />
            </a>
            <a [href]="appConfig.android" class="store-icon" target="_blank" rel="noopener noreferrer">
                <img src="/assets/img/aec-wallet/google-play.svg" alt="Google Play" />
            </a>
            <a [href]="appConfig.huawei" class="store-icon" target="_blank" rel="noopener noreferrer">
                <img src="/assets/img/aec-wallet/huawei-app-gallery.svg" alt="Huawei App Gallery" />
            </a>
        </div>  
    </div>
</div>